import React, { useState, useEffect, useRef } from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

export const AssessmentPartTwoModal = ({ open, setOpen, callback }) => {
    const [secondsRemaining, setSecondsRemaining] = useState(5);
    const modalRef = useRef(null);

    useEffect(() => {
        let intervalId;

        if (open) {
            setSecondsRemaining(5);
            intervalId = setInterval(() => {
                setSecondsRemaining(prevSeconds => {
                    if (prevSeconds <= 1) {
                        clearInterval(intervalId);
                        setOpen(false);
                        callback();
                        return 0;
                    }
                    return prevSeconds - 1;
                });
            }, 1000);
        }

        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [open, setOpen, callback]);

    const toggleModal = () => {
        setOpen(!open);
        callback();
    };

    return <Modal innerRef={modalRef} isOpen={open} toggle={toggleModal} centered size='md' className='close-circle'>
        <ModalHeader toggle={toggleModal} className='justify-content-center border-0 pb-0' cssModule={{ 'open-title': 'open-title libre-caslon-text-regular h4 mt-3' }}>You completed the Mind Patterns assessment</ModalHeader>
        <ModalBody>
            <div className='text-center'>
                <div className='icon mb-4 rounded-circle bg-green p-3 d-inline-block text-white mx-auto'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill='currentColor'>
                        <path d="M38,14.7L18,34.8c-0.5,0.5-1.1,0.7-1.8,0.7c-0.7,0-1.3-0.3-1.8-0.7L3.2,23.5c-0.5-0.5-0.7-1.1-0.7-1.8
                c0-0.7,0.3-1.3,0.7-1.8l3.1-3.1c0.5-0.5,1.1-0.7,1.8-0.7c0.7,0,1.3,0.3,1.8,0.7l6.4,6.2L31.4,8.1c0.5-0.5,1.1-0.7,1.8-0.7
                s1.3,0.3,1.8,0.7l3.1,3.1c0.2,0.2,0.4,0.5,0.5,0.8c0.1,0.3,0.2,0.6,0.2,1c0,0.3-0.1,0.7-0.2,1C38.4,14.2,38.3,14.5,38,14.7z"/>
                    </svg>
                </div>
                <p className='h4 font-weight-semibold'>Congratulations!</p>
                <p className='h5 font-weight-normal mb-4'>Now review and submit your results</p>
                <p className='text-muted'><small>Redirecting to review & rearrange in {secondsRemaining}s</small></p>
            </div>
        </ModalBody>
    </Modal>
}